import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 16h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16.5 9.4 7.55 4.24", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "3.29 7 12 12 20.71 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "22", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PackageMinus";
const PackageMinus = memo(themed(Icon));
export {
  PackageMinus
};
//# sourceMappingURL=package-minus.js.map
